import { MeilisearchAttribute } from '../../../entities/@api/Meilisearch';

interface ReplaceDynamicFiltersType {
    attribute: MeilisearchAttribute;
}

interface ReplaceDynamicFiltersConfig <T>{
    dynamicFilters?: T[];
    staticFilters?: T[];
    staticFilterAttributes?: MeilisearchAttribute[];
}

export const replaceDynamicWithStaticFilters = <T extends ReplaceDynamicFiltersType>(config: ReplaceDynamicFiltersConfig<T>): T[] => {
    const { dynamicFilters = [], staticFilters = [], staticFilterAttributes = [] } = config;

    if (staticFilters.length === 0) {
        return dynamicFilters;
    }

    return staticFilters.map(staticFilter => {
        if (!staticFilterAttributes.includes(staticFilter.attribute)) {
            const foundStaticFilter = dynamicFilters.find(dynamicFilter => dynamicFilter.attribute === staticFilter.attribute);

            return foundStaticFilter || staticFilter;
        }

        return staticFilter;
    });
};
